import { defineMessages } from 'react-intl';

export default defineMessages({
  versementsEncours: {
    id: 'releve_situation.versements_encours',
  },
  tauxFraisTitle: {
    id: 'taux_frais.title',
  },
  montantFraisPréleve: {
    id: 'montant_frais_prelevés.title',
  },
  versmentsNette: {
    id: 'versements_nets.title',
  },
  versementsNetteDescription: {
    id: 'versements_nets.description',
  },
  versementsNetteValorises: {
    id: 'versements_nets_valorisés.title',
  },
});
